package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val HotAirBalloon: ImageVector
    get() {
        if (_HotAirBalloon != null) {
            return _HotAirBalloon!!
        }
        _HotAirBalloon = ImageVector.Builder(
            name = "HotAirBalloon",
            defaultWidth = 597.41.dp,
            defaultHeight = 849.75.dp,
            viewportWidth = 597.41f,
            viewportHeight = 849.75f
        ).apply {
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(243.68f, 755.74f)
                curveTo(243.31f, 755.74f, 242.95f, 755.54f, 242.75f, 755.19f)
                lineTo(30.67f, 372.85f)
                curveTo(30.39f, 372.34f, 30.57f, 371.69f, 31.08f, 371.41f)
                curveTo(31.59f, 371.12f, 32.24f, 371.31f, 32.52f, 371.82f)
                lineTo(244.6f, 754.17f)
                curveTo(244.89f, 754.68f, 244.7f, 755.32f, 244.19f, 755.61f)
                curveTo(244.03f, 755.7f, 243.85f, 755.74f, 243.68f, 755.74f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(361.85f, 755.74f)
                curveTo(361.69f, 755.74f, 361.51f, 755.7f, 361.36f, 755.61f)
                curveTo(360.84f, 755.34f, 360.65f, 754.7f, 360.92f, 754.18f)
                lineTo(564.92f, 371.84f)
                curveTo(565.2f, 371.32f, 565.84f, 371.12f, 566.35f, 371.4f)
                curveTo(566.87f, 371.68f, 567.07f, 372.32f, 566.79f, 372.83f)
                lineTo(362.79f, 755.18f)
                curveTo(362.6f, 755.54f, 362.23f, 755.74f, 361.85f, 755.74f)
                close()
            }
            path(fill = SolidColor(Color(0xFFAAE1E2))) {
                moveTo(84.07f, 80.84f)
                curveTo(84.07f, 80.84f, -21.62f, 125.69f, 4.01f, 295.25f)
                curveTo(19.86f, 400.14f, 126.15f, 491.28f, 201.76f, 559.38f)
                curveTo(206.7f, 557.39f, 212.13f, 555.43f, 218.07f, 553.59f)
                curveTo(155.18f, 480f, 69.04f, 367.73f, 57.91f, 293.38f)
                curveTo(40.13f, 174.6f, 84.07f, 80.84f, 84.07f, 80.84f)
                close()
            }
            path(fill = SolidColor(Color(0xFFAAE1E2))) {
                moveTo(513.33f, 80.84f)
                curveTo(513.33f, 80.84f, 557.28f, 174.6f, 539.5f, 293.38f)
                curveTo(528.37f, 367.72f, 442.23f, 480f, 379.34f, 553.59f)
                curveTo(385.31f, 555.36f, 390.83f, 557.25f, 395.89f, 559.17f)
                curveTo(471.47f, 491.05f, 577.56f, 401.44f, 593.4f, 296.66f)
                curveTo(619.03f, 127.09f, 513.33f, 80.84f, 513.33f, 80.84f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF26545))) {
                moveTo(187.24f, 36.48f)
                curveTo(187.24f, 36.48f, 31.87f, 36.91f, 37.44f, 224.46f)
                curveTo(41.03f, 345.08f, 142.35f, 477.34f, 214.22f, 556.38f)
                curveTo(223.72f, 553f, 234.74f, 549.87f, 247.34f, 547.43f)
                curveTo(201.44f, 469.92f, 139.79f, 352.32f, 132.2f, 268.54f)
                curveTo(119.94f, 133.14f, 187.24f, 36.48f, 187.24f, 36.48f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF26545))) {
                moveTo(410.17f, 36.48f)
                curveTo(410.17f, 36.48f, 477.47f, 133.14f, 465.21f, 268.54f)
                curveTo(457.66f, 351.85f, 396.66f, 468.61f, 350.84f, 546.12f)
                curveTo(363.68f, 548.18f, 375.18f, 550.94f, 385.33f, 554.02f)
                curveTo(457.05f, 474.73f, 556.42f, 343.88f, 559.97f, 224.46f)
                curveTo(565.54f, 36.91f, 410.17f, 36.48f, 410.17f, 36.48f)
                close()
            }
            path(fill = SolidColor(Color(0xFFAAE1E2))) {
                moveTo(478.58f, 191.26f)
                curveTo(464.09f, -3.31f, 324.98f, 9.19f, 324.98f, 9.19f)
                curveTo(324.98f, 9.19f, 374.92f, 146.12f, 373.8f, 224.35f)
                curveTo(373.06f, 276.86f, 339.82f, 440.59f, 318.05f, 542.59f)
                curveTo(331.82f, 543.5f, 344.38f, 545.26f, 355.76f, 547.54f)
                curveTo(411.68f, 460.1f, 487.87f, 315.96f, 478.58f, 191.26f)
                close()
            }
            path(fill = SolidColor(Color(0xFFAAE1E2))) {
                moveTo(272.43f, 9.19f)
                curveTo(272.43f, 9.19f, 133.32f, -3.31f, 118.83f, 191.26f)
                curveTo(109.56f, 315.72f, 185.44f, 459.54f, 241.33f, 547.03f)
                curveTo(252.68f, 544.81f, 265.33f, 543.15f, 279.32f, 542.38f)
                curveTo(257.54f, 440.37f, 224.35f, 276.82f, 223.61f, 224.35f)
                curveTo(222.49f, 146.12f, 272.43f, 9.19f, 272.43f, 9.19f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF26545))) {
                moveTo(299.74f, 0f)
                curveTo(262.9f, 0f, 216.04f, 48.19f, 216.04f, 215.15f)
                curveTo(216.04f, 320.39f, 248.58f, 456.86f, 272.64f, 543.39f)
                curveTo(280.61f, 542.74f, 289.04f, 542.39f, 297.95f, 542.39f)
                curveTo(308.41f, 542.39f, 318.29f, 542.88f, 327.58f, 543.75f)
                curveTo(354.59f, 456.72f, 390.72f, 320.65f, 390.72f, 216.09f)
                curveTo(390.72f, 49.13f, 336.59f, 0f, 299.74f, 0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF26545))) {
                moveTo(201.76f, 559.38f)
                curveTo(201.76f, 559.38f, 249.08f, 537.77f, 303.38f, 537.1f)
                curveTo(357.68f, 536.43f, 395.89f, 559.17f, 395.89f, 559.17f)
                curveTo(395.89f, 559.17f, 374.53f, 601.82f, 375.27f, 639.94f)
                curveTo(375.27f, 639.94f, 337.53f, 621.75f, 303.38f, 621.75f)
                curveTo(269.23f, 621.75f, 231.67f, 639.94f, 231.67f, 639.94f)
                curveTo(231.67f, 639.94f, 226.44f, 582.25f, 201.76f, 559.38f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC13E29))) {
                moveTo(231.67f, 639.94f)
                arcToRelative(18.14f, 71.8f, 90f, isMoreThanHalf = true, isPositiveArc = false, 143.6f, 0f)
                arcToRelative(18.14f, 71.8f, 90f, isMoreThanHalf = true, isPositiveArc = false, -143.6f, 0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(359.36f, 756.28f)
                curveTo(359.35f, 756.28f, 359.35f, 756.28f, 359.34f, 756.28f)
                curveTo(358.82f, 756.23f, 358.45f, 755.8f, 358.5f, 755.29f)
                lineTo(371.04f, 641.11f)
                lineTo(321.67f, 693.27f)
                lineTo(359.33f, 629.06f)
                curveTo(359.59f, 628.61f, 360.17f, 628.46f, 360.62f, 628.72f)
                curveTo(361.07f, 628.97f, 361.23f, 629.54f, 360.97f, 629.98f)
                lineTo(331.6f, 680.06f)
                lineTo(373.53f, 635.77f)
                lineTo(360.38f, 755.5f)
                curveTo(360.32f, 756f, 359.87f, 756.33f, 359.36f, 756.28f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(242.74f, 756.15f)
                curveTo(242.58f, 756.15f, 242.42f, 756.11f, 242.27f, 756.02f)
                curveTo(241.82f, 755.77f, 241.67f, 755.2f, 241.93f, 754.76f)
                lineTo(280.74f, 689.1f)
                lineTo(282.42f, 689.93f)
                lineTo(254.14f, 753.99f)
                curveTo(253.93f, 754.46f, 253.37f, 754.68f, 252.9f, 754.47f)
                curveTo(252.42f, 754.27f, 252.2f, 753.73f, 252.4f, 753.26f)
                lineTo(274.27f, 703.73f)
                lineTo(243.56f, 755.68f)
                curveTo(243.39f, 755.98f, 243.07f, 756.15f, 242.74f, 756.15f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(363f, 756.15f)
                curveTo(362.68f, 756.15f, 362.36f, 755.98f, 362.18f, 755.68f)
                lineTo(331.48f, 703.73f)
                lineTo(353.34f, 753.26f)
                curveTo(353.55f, 753.73f, 353.33f, 754.27f, 352.85f, 754.47f)
                curveTo(352.37f, 754.68f, 351.82f, 754.46f, 351.61f, 753.99f)
                lineTo(323.33f, 689.93f)
                lineTo(325.01f, 689.1f)
                lineTo(363.82f, 754.76f)
                curveTo(364.08f, 755.2f, 363.93f, 755.77f, 363.47f, 756.02f)
                curveTo(363.33f, 756.11f, 363.16f, 756.15f, 363f, 756.15f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(323.49f, 689.89f)
                curveTo(323.27f, 689.86f, 323.06f, 689.74f, 322.9f, 689.55f)
                curveTo(322.56f, 689.12f, 322.61f, 688.48f, 323.02f, 688.11f)
                lineTo(369.09f, 646.41f)
                curveTo(369.49f, 646.04f, 370.1f, 646.09f, 370.44f, 646.51f)
                curveTo(370.78f, 646.94f, 370.73f, 647.58f, 370.32f, 647.95f)
                lineTo(324.25f, 689.65f)
                curveTo(324.03f, 689.85f, 323.75f, 689.93f, 323.49f, 689.89f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(247.47f, 756.28f)
                curveTo(247.47f, 756.28f, 247.48f, 756.28f, 247.49f, 756.28f)
                curveTo(248f, 756.23f, 248.38f, 755.8f, 248.33f, 755.29f)
                lineTo(235.79f, 641.11f)
                lineTo(285.16f, 693.27f)
                lineTo(247.49f, 629.06f)
                curveTo(247.24f, 628.61f, 246.66f, 628.46f, 246.21f, 628.72f)
                curveTo(245.75f, 628.97f, 245.6f, 629.54f, 245.86f, 629.98f)
                lineTo(275.23f, 680.06f)
                lineTo(233.3f, 635.77f)
                lineTo(246.45f, 755.5f)
                curveTo(246.5f, 756f, 246.96f, 756.33f, 247.47f, 756.28f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA3311D))) {
                moveTo(283.34f, 689.89f)
                curveTo(283.56f, 689.86f, 283.77f, 689.74f, 283.93f, 689.55f)
                curveTo(284.27f, 689.12f, 284.21f, 688.48f, 283.81f, 688.11f)
                lineTo(237.74f, 646.41f)
                curveTo(237.33f, 646.04f, 236.73f, 646.09f, 236.39f, 646.51f)
                curveTo(236.04f, 646.94f, 236.1f, 647.58f, 236.51f, 647.95f)
                lineTo(282.57f, 689.65f)
                curveTo(282.79f, 689.85f, 283.08f, 689.93f, 283.34f, 689.89f)
                close()
            }
            path(fill = SolidColor(Color(0xFF914A1A))) {
                moveTo(302.88f, 753.44f)
                lineTo(260.24f, 753.44f)
                curveTo(255.12f, 753.44f, 244.93f, 757.1f, 244.93f, 762.1f)
                lineTo(247.67f, 779.5f)
                lineTo(302.88f, 782.58f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA0531F))) {
                moveTo(247.67f, 779.48f)
                lineTo(256.51f, 840.78f)
                curveTo(256.51f, 845.78f, 260.63f, 849.75f, 265.75f, 849.75f)
                lineTo(302.88f, 849.75f)
                lineTo(302.88f, 782.58f)
                close()
            }
            path(fill = SolidColor(Color(0xFF7F4016))) {
                moveTo(357.47f, 785.66f)
                lineTo(361.86f, 761.27f)
                curveTo(361.86f, 756.26f, 350.62f, 753.44f, 345.51f, 753.44f)
                lineTo(302.88f, 753.44f)
                lineTo(302.88f, 782.58f)
                close()
            }
            path(fill = SolidColor(Color(0xFF914A1A))) {
                moveTo(302.88f, 782.58f)
                lineTo(302.88f, 849.75f)
                lineTo(339.81f, 849.75f)
                curveTo(344.93f, 849.75f, 349.08f, 845.78f, 349.08f, 840.78f)
                lineTo(357.47f, 785.61f)
                close()
            }
            path(fill = SolidColor(Color(0xFF601C13))) {
                moveTo(311.02f, 666.92f)
                lineTo(310.56f, 666.92f)
                lineTo(310.56f, 652.74f)
                curveTo(310.56f, 649.13f, 306.99f, 646.2f, 302.62f, 646.2f)
                curveTo(298.25f, 646.2f, 294.68f, 649.13f, 294.68f, 652.74f)
                lineTo(294.68f, 666.75f)
                curveTo(287.54f, 666.75f, 281.45f, 672.54f, 281.45f, 679.68f)
                lineTo(281.45f, 698.61f)
                curveTo(281.45f, 705.75f, 287.43f, 711.37f, 294.73f, 711.37f)
                lineTo(311.02f, 711.37f)
                curveTo(318.32f, 711.37f, 324.31f, 705.75f, 324.31f, 698.61f)
                lineTo(324.31f, 679.68f)
                curveTo(324.31f, 672.54f, 318.32f, 666.92f, 311.02f, 666.92f)
                close()
            }
            path(fill = SolidColor(Color(0xFF8FD0D5))) {
                moveTo(266.57f, 786.59f)
                curveTo(266.41f, 786.59f, 266.25f, 786.59f, 266.09f, 786.58f)
                curveTo(258.33f, 786.45f, 253.36f, 783.38f, 250.55f, 780.82f)
                curveTo(247.5f, 778.03f, 246.3f, 775.28f, 246.25f, 775.16f)
                curveTo(246.05f, 774.69f, 246.28f, 774.15f, 246.76f, 773.96f)
                curveTo(247.24f, 773.76f, 247.79f, 773.98f, 247.99f, 774.45f)
                curveTo(248f, 774.48f, 249.12f, 777.01f, 251.91f, 779.53f)
                curveTo(255.63f, 782.89f, 260.41f, 784.64f, 266.12f, 784.74f)
                curveTo(279.71f, 784.96f, 283.18f, 774.64f, 283.21f, 774.53f)
                curveTo(283.37f, 774.05f, 283.9f, 773.77f, 284.39f, 773.93f)
                curveTo(284.89f, 774.08f, 285.17f, 774.6f, 285.01f, 775.08f)
                curveTo(284.97f, 775.21f, 284.02f, 778.1f, 281.21f, 780.97f)
                curveTo(278.67f, 783.55f, 274.09f, 786.59f, 266.57f, 786.59f)
                close()
            }
            path(fill = SolidColor(Color(0xFF8FD0D5))) {
                moveTo(303.6f, 786.59f)
                curveTo(303.44f, 786.59f, 303.28f, 786.59f, 303.12f, 786.58f)
                curveTo(295.36f, 786.45f, 290.39f, 783.38f, 287.58f, 780.82f)
                curveTo(284.53f, 778.03f, 283.33f, 775.28f, 283.28f, 775.16f)
                curveTo(283.08f, 774.69f, 283.3f, 774.15f, 283.79f, 773.96f)
                curveTo(284.27f, 773.76f, 284.82f, 773.98f, 285.02f, 774.45f)
                curveTo(285.03f, 774.48f, 286.15f, 777.01f, 288.94f, 779.53f)
                curveTo(292.65f, 782.89f, 297.44f, 784.64f, 303.15f, 784.74f)
                curveTo(303.3f, 784.74f, 303.45f, 784.74f, 303.6f, 784.74f)
                curveTo(316.81f, 784.74f, 320.21f, 774.63f, 320.24f, 774.53f)
                curveTo(320.4f, 774.05f, 320.93f, 773.77f, 321.42f, 773.93f)
                curveTo(321.92f, 774.08f, 322.2f, 774.6f, 322.04f, 775.08f)
                curveTo(322f, 775.21f, 321.05f, 778.1f, 318.24f, 780.97f)
                curveTo(315.7f, 783.55f, 311.12f, 786.59f, 303.6f, 786.59f)
                close()
            }
            path(fill = SolidColor(Color(0xFF8FD0D5))) {
                moveTo(340.63f, 786.59f)
                curveTo(340.47f, 786.59f, 340.31f, 786.59f, 340.15f, 786.58f)
                curveTo(332.39f, 786.45f, 327.41f, 783.38f, 324.61f, 780.82f)
                curveTo(321.56f, 778.03f, 320.36f, 775.28f, 320.31f, 775.16f)
                curveTo(320.11f, 774.69f, 320.33f, 774.15f, 320.81f, 773.96f)
                curveTo(321.29f, 773.76f, 321.85f, 773.98f, 322.05f, 774.45f)
                curveTo(322.06f, 774.48f, 323.18f, 777.01f, 325.96f, 779.53f)
                curveTo(329.68f, 782.89f, 334.47f, 784.64f, 340.18f, 784.74f)
                curveTo(353.77f, 784.96f, 357.23f, 774.64f, 357.27f, 774.53f)
                curveTo(357.42f, 774.05f, 357.95f, 773.77f, 358.45f, 773.93f)
                curveTo(358.95f, 774.08f, 359.23f, 774.6f, 359.07f, 775.08f)
                curveTo(359.03f, 775.21f, 358.08f, 778.1f, 355.26f, 780.97f)
                curveTo(352.73f, 783.55f, 348.14f, 786.59f, 340.63f, 786.59f)
                close()
            }
            path(fill = SolidColor(Color(0xFF914A1A))) {
                moveTo(356.9f, 753.44f)
                lineTo(302.88f, 753.44f)
                lineTo(302.88f, 774.6f)
                lineTo(356.9f, 774.6f)
                curveTo(362.01f, 774.6f, 366.12f, 771.53f, 366.12f, 767.42f)
                lineTo(366.12f, 760.77f)
                curveTo(366.12f, 756.66f, 362.01f, 753.44f, 356.9f, 753.44f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA0531F))) {
                moveTo(248.85f, 753.44f)
                curveTo(243.73f, 753.44f, 239.65f, 756.66f, 239.65f, 760.77f)
                lineTo(239.65f, 767.42f)
                curveTo(239.65f, 771.53f, 243.73f, 774.6f, 248.85f, 774.6f)
                lineTo(302.88f, 774.6f)
                lineTo(302.88f, 753.44f)
                close()
            }
            path(fill = SolidColor(Color(0xFF601C13))) {
                moveTo(268.94f, 786.42f)
                lineTo(273.15f, 780.42f)
                lineTo(258.68f, 780.42f)
                lineTo(263.37f, 786.25f)
                curveTo(259.29f, 789.9f, 254.71f, 797.65f, 254.71f, 804.38f)
                curveTo(254.71f, 813.31f, 259.79f, 816.22f, 266.05f, 816.22f)
                curveTo(272.31f, 816.22f, 277.38f, 813.32f, 277.38f, 804.38f)
                curveTo(277.38f, 797.64f, 273.04f, 790.06f, 268.94f, 786.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFF601C13))) {
                moveTo(305.76f, 786.42f)
                lineTo(309.98f, 780.42f)
                lineTo(295.5f, 780.42f)
                lineTo(300.2f, 786.25f)
                curveTo(296.11f, 789.9f, 291.54f, 797.65f, 291.54f, 804.38f)
                curveTo(291.54f, 813.31f, 296.62f, 816.22f, 302.87f, 816.22f)
                curveTo(309.13f, 816.22f, 314.21f, 813.32f, 314.21f, 804.38f)
                curveTo(314.21f, 797.64f, 309.87f, 790.06f, 305.76f, 786.42f)
                close()
            }
            path(fill = SolidColor(Color(0xFF601C13))) {
                moveTo(342.59f, 786.42f)
                lineTo(346.81f, 780.42f)
                lineTo(332.33f, 780.42f)
                lineTo(337.03f, 786.25f)
                curveTo(332.94f, 789.9f, 328.37f, 797.65f, 328.37f, 804.38f)
                curveTo(328.37f, 813.31f, 333.44f, 816.22f, 339.7f, 816.22f)
                curveTo(345.96f, 816.22f, 351.03f, 813.32f, 351.03f, 804.38f)
                curveTo(351.03f, 797.64f, 346.7f, 790.06f, 342.59f, 786.42f)
                close()
            }
        }.build()

        return _HotAirBalloon!!
    }

@Suppress("ObjectPropertyName")
private var _HotAirBalloon: ImageVector? = null
